import React from 'react'
import { ActiveLoansColumns, ActiveLoansTableData } from './ActiveLoansData';

import DataTable from '../../../../Common/DataTable/DataTable';
import DataTableHeader from '../../../../Common/DataTableHeader/DataTableHeader';
import DataTableFooter from '../../../../Common/DataTableFooter/DataTableFooter';

const ActiveLoansTable = () => {
    const dataT = ActiveLoansTableData.map((data) => {
        return {
            slNo: data.slNo,
            loanMoney: data.loanMoney,
            leftToRepay: data.leftToRepay,
            duration: data.duration,
            interestRate: data.interestRate,
            installment: data.installment,
            repay: (
                <button type="button"
                    className="btn rounded-5 px-4 btn-outline-primary"
                    data-bs-toggle="modal" data-bs-target="#exampleModal"
                    data-bs-whatever="@fat">Repay</button>
            )
        };
    });
    return (
        <div>
            <DataTableHeader />
            <DataTable columns={ActiveLoansColumns} data={dataT} />
            <DataTableFooter dataT={dataT} />
        </div>
    )
}

export default ActiveLoansTable